<template>
  <div
    id="sticky-shop-now"
    class="flex justify-center z-30 fixed bottom-0 left-0 right-0 pt-8 p-4 bg-transparent from-transparent to-white bg-linear-to-b transition-transform pointer-events-none"
    :class="hidden ? 'translate-y-full' : 'drop-shadow-top'"
  >
    <div class="flex grow gap-4 max-w-sm pointer-events-auto">
      <a
        :href="href"
        class="button +green text-xl! grow"
        data-gtm-action="sticky shop now click"
      >
        <span>Shop Now</span>
      </a>
      <button
        v-if="top && !hideBackToTop"
        class="button border-2 flex gap-2 bg-white text-gray-600"
        @click="$theme.scrollToSelector(top)"
      >
        Top
        <svg-icon
          name="arrow-up"
          class="w-4 h-4"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

export interface Props {
  top: string
  bottom: string
  animationName?: string
  hideBackToTop?: boolean
  href?: string
}

const props = withDefaults(defineProps<Props>(), {
  href: '/products/custom-bundle'
})
const hidden = ref(true)

const firstVisible = (selector: string) => {
  return Array.from(document.querySelectorAll(selector)).find(i => i.checkVisibility())
}

const init = () => {
  const $top = firstVisible(props.top)
  const $bottom = firstVisible(props.bottom)

  const observer = new IntersectionObserver(entries => {
    hidden.value = entries.some(i => i.isIntersecting)
  })

  const activate = () => {
    if ($top) {
      observer.observe($top)
    }
    if ($bottom) {
      observer.observe($bottom)
    }
  }

  if (props.animationName) {
    window.addEventListener('animationstart', ({ animationName }) => {
      if (animationName === props.animationName) {
        activate()
      }
    })
  } else {
    activate()
  }
}

onMounted(() => {
  setTimeout(init, 500)
})
</script>
